import {
  Coupon,
  NowQuery,
  OptionContract,
  Plan,
} from "@/generated/graphql_billing";
import { color } from "@/styles/theme";
import React, { createContext } from "react";

type Props = {
  now: NowQuery["now"];
  plan: Plan;
  optionContracts?: OptionContract["option"][];
  coupon?: Coupon;
  children?: React.ReactNode;
};

export type PlanBoxContextType = {
  plan: Plan;
  optionContracts?: OptionContract["option"][];
  coupon?: Coupon;
  now?: NowQuery["now"];
};

export const PlanBoxContext = createContext<PlanBoxContextType | null>(null);

export const PlanBox = ({
  now,
  plan,
  optionContracts = [],
  coupon,
  children,
}: Props) => {
  const ctx = {
    now,
    plan,
    optionContracts,
    coupon,
  };

  return (
    <div
      css={{
        border: `solid 1px ${color.gray300}`,
        borderRadius: "4px",
        backgroundColor: color.white,

        width: "100%",
        maxWidth: 800,
      }}
    >
      <PlanBoxContext.Provider value={ctx}>{children}</PlanBoxContext.Provider>
    </div>
  );
};
